/* Outstanding Bids search filters reducer */

import * as _ from 'lodash';

import * as Actions from '../actions';
import { DateRanges } from '../common/dateranges';
import { OrderStatuses } from '../order/orderpricing';

export interface ISearchFiltersOutstandingBidsState {
    clientId: any;
    fromFollowUpDate: string;
    toFollowUpDate: string;
    fromBidDate: string;
    regionId: any;
    statusId: any;
    toBidDate: string;
    unsolicitedBid: any;
    selectedOrderIds: any;
}

const defaultFromBidDateRangeValue = DateRanges.DateRangeOptionValues.LAST_SIX_MONTHS;
const defaultFromFollowUpDateRangeValue = DateRanges.DateRangeOptionValues.LAST_SIX_MONTHS;
const defaultToFollowUpDateRangeValue = DateRanges.DateRangeOptionValues.END_OF_TODAY;

export const initialState: ISearchFiltersOutstandingBidsState = {
    clientId: -1,
    fromFollowUpDate: '', // DateRanges.getStartDate(defaultFromFollowUpDateRangeValue),
    toFollowUpDate: '', // DateRanges.getEndDate(defaultToFollowUpDateRangeValue),
    fromBidDate: DateRanges.getStartDate(defaultFromBidDateRangeValue),
    regionId: -1,
    statusId: OrderStatuses.BID_SENT_LIMBO,
    toBidDate: '',
    unsolicitedBid: -1,
    selectedOrderIds: [],
};

export function searchFiltersOutstandingBidsReducer(state: ISearchFiltersOutstandingBidsState = initialState, action: any): ISearchFiltersOutstandingBidsState {
    switch (action.type) {
        case Actions.SEARCH_OUTSTANDING_BIDS_CLIENT:
            return _.merge({}, state, { clientId: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_STATUS:
            return _.merge({}, state, { statusId: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_REGION:
            return _.merge({}, state, { regionId: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_FROM_BID_DATE:
            return _.merge({}, state, { fromBidDate: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_TO_BID_DATE:
            return _.merge({}, state, { toBidDate: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_FROM_FOLLOW_UP_DATE:
            return _.merge({}, state, { fromFollowUpDate: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_TO_FOLLOW_UP_DATE:
            return _.merge({}, state, { toFollowUpDate: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_UNSOLICITED_BID:
            return _.merge({}, state, { unsolicitedBid: action.value });
        case Actions.SEARCH_OUTSTANDING_BIDS_SELECTED_ORDER_IDS:
            return _.merge({}, state, { selectedOrderIds: action.value });
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/searchFiltersOutstandingBidsReducer.tsx